export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const DOWNLOAD_DATA = 'DOWNLOAD_DATA';
export const LIST_PRODUCTS = 'LIST_PRODUCTS';
